import { render, staticRenderFns } from "./EditCountryDocument.vue?vue&type=template&id=58cd56b2&scoped=true&"
import script from "./EditCountryDocument.vue?vue&type=script&lang=js&"
export * from "./EditCountryDocument.vue?vue&type=script&lang=js&"
import style0 from "./EditCountryDocument.vue?vue&type=style&index=0&id=58cd56b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cd56b2",
  null
  
)

export default component.exports